var React = require('react/addons');
var cx = require('classnames');


var Column = React.createClass({
  getDefaultProps: function() {
    return {
      size: 'full'
    };
  },

  render: function() {
    var classNames = cx(
      'ofs-Grid__Column',
      'ofs-Grid__Column--' + this.props.size
    );

    return (
      <div className={classNames}>
        {this.props.children}
      </div>
    );
  }
});

module.exports = Column;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/layout/column.jsx
 **/